import type { EntryPoint, Shell } from '#packages/apilib';
import {
  EditorAPIKey,
  ThemeApiKey,
  WorkspaceRightPanelApiKey,
  RtlLtrSettingsManagerKey,
} from '#packages/apis';
import { A11yAdapterApiKey } from './a11yWizardAdapterAPI';
import { createA11yWizardAdapterAPI } from './createA11yWizardAdapterAPI';

export const A11yWizardEntryPoint: EntryPoint = {
  name: 'a11yWizardAdapterEntry',

  layer: 'UI',
  getDependencyAPIs() {
    return [
      WorkspaceRightPanelApiKey,
      EditorAPIKey,
      ThemeApiKey,
      RtlLtrSettingsManagerKey,
    ];
  },

  declareAPIs() {
    return [A11yAdapterApiKey];
  },

  attach(shell: Shell) {
    shell.contributeAPI(A11yAdapterApiKey, () =>
      createA11yWizardAdapterAPI(shell),
    );
  },
};
